// removed by extract-text-webpack-plugin
module.exports = {"anim_body":"index_2aYtGQJ","anim_element":"index_21sgeX_","bg":"index_13uchs-","thumb":"index__Wi-C8I","inactive":"index_1YvuAg9","active":"index_18islB4","userArrow":"index_2C_aBQz","userArrowPrev":"index_15-Cg_P index_2C_aBQz","userArrowNext":"index_1qhUUtv index_2C_aBQz","userthumb":"index_IYy9tRw","thumb_active":"index_SFyUTaO"};


//////////////////
// WEBPACK FOOTER
// ./src/component/big_banner/index.css
// module id = 963
// module chunks = 0